import { ServerFetch } from '../main-model'

export default class PaymentPayModel extends ServerFetch {
    getPaymentPayBy = (data) => this.authFetch({
        url: 'payment-pay/getPaymentPayBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}